export const messages = {
  en: {
    communityFeeSummary: {
      search: {
        title: 'Search Conditions',
        startDate: 'Start Date',
        endDate: 'End Date',
        feeType: 'Fee Type',
        selectFeeType: 'Please select fee type',
        allCommunities: 'All Communities'
      },
      table: {
        title: 'Fee Summary Report',
        tooltip: 'Summarize fee information by month',
        updateDaily: 'Updated daily',
        totalRooms: 'Total Rooms',
        feeRooms: 'Fee Rooms',
        oweRooms: 'Owe Rooms',
        oweFeeFormula: 'History Owe + Current Owe = Total Owe',
        hisOweFee: 'History Owe',
        curOweFee: 'Current Owe',
        totalOweFee: 'Total Owe',
        receivedFeeFormula: 'Owe Recovery + Current Partial + Prepayment = Actual Payment',
        hisReceivedFee: 'Owe Recovery',
        curPartialFee: 'Current Partial',
        preReceivedFee: 'Prepayment',
        totalReceivedFee: 'Actual Payment',
        curReceivableFee: 'Current Receivable',
        curReceivedFee: 'Current Received',
        roomFeeRate: 'Paid Rooms/Fee Rooms = Room Fee Rate',
        feeRate: 'Current Received/Current Receivable = Fee Rate',
        clearRate: 'Owe Recovery/(Owe Recovery + History Owe) = Clear Rate'
      },
      fetchError: 'Failed to fetch fee summary data',
      multiCommunityFeeSummary: {
        search: {
          title: 'Search Conditions',
          community: 'Community',
          placeholderCommunity: 'Please select community',
          monthRange: 'Date Range',
          placeholderMonthRange: 'Please select date range',
          rangeSeparator: 'To',
          placeholderStartDate: 'Start date',
          placeholderEndDate: 'End date',
          feeType: 'Fee Type',
          placeholderFeeType: 'Please select fee type',
          feeState: 'Fee State',
          placeholderFeeState: 'Please select fee state',
          stateWait: 'Pending',
          stateComplete: 'Paid',
          stateRefund: 'Refunded',
          search: 'Search',
          reset: 'Reset'
        },
        tab: {
          byCommunity: 'By Community',
          byDetail: 'By Detail'
        },
        indicatorExplanation: 'Indicator Explanation',
        table: {
          communityName: 'Community Name',
          totalRoomCount: 'Total Rooms',
          feeRoomCount: 'Charged Rooms',
          oweRoomCount: 'Owe Rooms',
          hisOweFee: 'History Owe',
          curReceivableFee: 'Current Receivable',
          curReceivedFee: 'Current Received',
          curOweFee: 'Current Owe',
          totalOweFee: 'Total Owe',
          actualPaid: 'Actual Paid',
          feeRoomRate: 'Room Rate',
          feeRate: 'Fee Rate',
          clearRate: 'Clear Rate',
          feeName: 'Fee Name',
          year: 'Year',
          month: 'Month',
          receivableAmountTotal: 'Receivable Total',
          receivedAmountTotal: 'Received Total',
          oweAmountTotal: 'Owe Total'
        },
        export: 'Export',
        fetchError: 'Failed to fetch multi-community fee summary data'
      },
      cashierFeeSummary: {
        search: {
          title: 'Search Conditions',
          community: 'Community',
          placeholderCommunity: 'Please select community',
          dateRange: 'Date Range',
          placeholderDateRange: 'Please select date range',
          feeType: 'Fee Type',
          placeholderFeeType: 'Please select fee type',
          search: 'Search',
          reset: 'Reset'
        },
        table: {
          cashierName: 'Cashier Name',
          feeCount: 'Fee Count',
          receivableAmount: 'Receivable Amount',
          receivedAmount: 'Received Amount',
          discountAmount: 'Discount Amount',
          acctAmount: 'Account Deduction'
        },
        export: 'Export',
        fetchError: 'Failed to fetch cashier fee summary data',
        exportSuccess: 'Export task submitted, please check file download page',
        exportError: 'Export failed',
        pleaseSelectCommunity: 'Please select a community',
        pleaseSelectDateRange: 'Please select date range'
      }
    }
  },
  zh: {
    communityFeeSummary: {
      search: {
        title: '查询条件',
        startDate: '开始时间',
        endDate: '结束时间',
        feeType: '费用大类',
        selectFeeType: '请选择费用大类',
        allCommunities: '全部小区'
      },
      table: {
        title: '费用汇总表',
        tooltip: '以月份为维度，进行费用情况汇总',
        updateDaily: '按天更新',
        totalRooms: '总户数',
        feeRooms: '收费户',
        oweRooms: '欠费户',
        oweFeeFormula: '历史欠费+当期欠费=欠费',
        hisOweFee: '历史欠费',
        curOweFee: '当期欠费',
        totalOweFee: '总欠费',
        receivedFeeFormula: '欠费追回+当期部分+预交=实缴',
        hisReceivedFee: '欠费追回',
        curPartialFee: '当期部分',
        preReceivedFee: '预交',
        totalReceivedFee: '实缴',
        curReceivableFee: '当期应收',
        curReceivedFee: '当期实收',
        roomFeeRate: '已交户/收费户=户收费率',
        feeRate: '当期实收/当期应收=收费率',
        clearRate: '欠费追回/(欠费追回+历史欠费)=清缴率'
      },
      fetchError: '获取费用汇总数据失败',
      multiCommunityFeeSummary: {
        search: {
          title: '查询条件',
          community: '小区',
          placeholderCommunity: '请选择小区',
          monthRange: '日期范围',
          placeholderMonthRange: '请选择日期范围',
          rangeSeparator: '至',
          placeholderStartDate: '开始日期',
          placeholderEndDate: '结束日期',
          feeType: '费用类型',
          placeholderFeeType: '请选择费用类型',
          feeState: '缴费状态',
          placeholderFeeState: '请选择缴费状态',
          stateWait: '待缴费',
          stateComplete: '已缴费',
          stateRefund: '已退费',
          search: '查询',
          reset: '重置'
        },
        tab: {
          byCommunity: '按小区汇总',
          byDetail: '按明细汇总'
        },
        indicatorExplanation: '指标说明',
        table: {
          communityName: '小区名称',
          totalRoomCount: '总户数',
          feeRoomCount: '收费户',
          oweRoomCount: '欠费户',
          hisOweFee: '历史欠费',
          curReceivableFee: '当期应收',
          curReceivedFee: '当期实收',
          curOweFee: '当期欠费',
          totalOweFee: '总欠费',
          actualPaid: '实缴',
          feeRoomRate: '户收费率',
          feeRate: '收费率',
          clearRate: '清缴率',
          feeName: '费用名称',
          year: '年份',
          month: '月份',
          receivableAmountTotal: '应收金额合计',
          receivedAmountTotal: '实收金额合计',
          oweAmountTotal: '欠费金额合计'
        },
        export: '导出',
        fetchError: '获取多小区费用汇总数据失败'
      },
      cashierFeeSummary: {
        search: {
          title: '查询条件',
          community: '小区',
          placeholderCommunity: '请选择小区',
          dateRange: '日期范围',
          placeholderDateRange: '请选择日期范围',
          feeType: '费用类型',
          placeholderFeeType: '请选择费用类型',
          search: '查询',
          reset: '重置'
        },
        table: {
          cashierName: '收费员',
          feeCount: '缴费笔数',
          receivableAmount: '应收金额（元）',
          receivedAmount: '实收金额（元）',
          discountAmount: '优惠金额（元）',
          acctAmount: '账户抵扣（元）'
        },
        export: '导出',
        fetchError: '获取收费员收费汇总数据失败',
        exportSuccess: '导出任务已提交，请到文件下载页面查看',
        exportError: '导出失败',
        pleaseSelectCommunity: '请选择小区',
        pleaseSelectDateRange: '请选择日期范围'
      }
    }
  }
}